<div class="row align-items-center">
    <div class="col-lg-9 mx-auto">
        <div class="logo-pet-eletronico">
            <img alt="OAB - Peticionamento Eletrônico" src="https://s.oab.org.br/imagens/marcas-sistemas/mono-negativa/2x/oab-pet-eletronico.png">
        </div>
    </div>
</div>
